import { DEFAULT_ZOOM } from '../constants';

export interface ViewportState {
  zoom: number;
  panX: number;
  panY: number;
  canvasWidth: number;
  canvasHeight: number;
}

type Listener = (state: ViewportState) => void;

class ViewportStore {
  private state: ViewportState = {
    zoom: DEFAULT_ZOOM,
    panX: 0,
    panY: 0,
    canvasWidth: 0,
    canvasHeight: 0,
  };
  private listeners = new Set<Listener>();

  getState(): ViewportState {
    return this.state;
  }

  setState(
    updates: Partial<ViewportState> | ((state: ViewportState) => Partial<ViewportState>)
  ) {
    const nextState = typeof updates === 'function' ? updates(this.state) : updates;
    
    // Check if anything actually changed to avoid redundant notifications
    let changed = false;
    for (const key in nextState) {
      const k = key as keyof ViewportState;
      if (this.state[k] !== nextState[k]) {
        changed = true;
        break;
      }
    }
    
    if (changed) {
      this.state = { ...this.state, ...nextState };
      this.listeners.forEach((listener) => listener(this.state));
    }
  }

  subscribe(listener: Listener) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const viewportStore = new ViewportStore();
